import { Link } from 'react-router-dom';

// Case-study cards, styled to match the Saks "Older/Personal Work"
// cards on the homepage (bg-white rounded-lg shadow-lg p-8).
const PROJECTS = {
  herba: {
    name: 'Herba',
    logo: '/images/herba_logo_color.png',
    logoMaxWidth: '160px',
    description: 'Making spaces effortlessly green by automating plant care.',
    to: '/work/herba',
  },
  cultureAmp: {
    name: 'Culture Amp',
    logo: '/images/cultureamp_logo.png',
    logoMaxWidth: '220px',
    description: "Rearchitecting Culture Amp's goals flow.",
    to: '/work/culture-amp',
  },
  disco: {
    name: 'Disco',
    logo: '/images/disco_logo_color.png',
    logoMaxWidth: '200px',
    description: 'Redesigning how teams celebrate each other.',
    to: '/work/disco',
  },
  flok: {
    name: 'Flok',
    logo: '/images/flok_logo.png',
    logoMaxWidth: '100px',
    description: 'Turning a paper punch card into an automated, beacon-powered club.',
    to: '/work/flok',
  },
  whosay: {
    name: 'WhoSay',
    logo: '/images/whosay_logo.png',
    logoMaxWidth: '150px',
    description: 'Helping celebrities publish to every platform at once.',
    to: '/work/whosay',
  },
};

// Shows every case study other than `current` so the footer never links
// back to the page the visitor is already on.
const OtherProjects = ({ current }) => {
  const others = Object.keys(PROJECTS).filter((key) => key !== current);

  return (
    <section className="border-t border-gray-light py-16 sm:py-20">
      <h2 className="text-2xl sm:text-3xl font-bold text-text-primary mb-8">View Other Projects</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {others.map((key) => {
          const project = PROJECTS[key];
          return (
            <div key={key} className="bg-white rounded-lg shadow-lg p-8">
              <div className="h-16 flex items-center justify-start mb-6">
                <img
                  src={project.logo}
                  alt={`${project.name} Logo`}
                  className="max-h-full object-contain"
                  style={{ maxWidth: project.logoMaxWidth }}
                />
              </div>
              <h3 className="text-2xl font-bold text-text-primary mb-3">{project.name}</h3>
              <p className="text-gray-600 mb-6">{project.description}</p>
              <Link to={project.to} className="inline-flex items-center text-secondary hover:underline font-medium">
                View Project →
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OtherProjects;
